import type { ReactNode } from "react";
import type { PillTone } from "@/lib/social-scoreboard";
import { PILL_TONE_CLASSES } from "@/lib/social-scoreboard-copy";
import { cn } from "@/lib/utils";

/** The prototype's status pill: one of the shared status tones. */
export function Pill({ tone, children }: { tone: PillTone; children: ReactNode }) {
  return (
    <span
      className={cn(
        "inline-block whitespace-nowrap rounded-full px-[9px] py-0.5 text-[11.5px] font-bold tracking-[.02em]",
        PILL_TONE_CLASSES[tone],
      )}
    >
      {children}
    </span>
  );
}
